import { render } from "./Customer.vue?vue&type=template&id=c47a2bc0&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=c47a2bc0&lang=stylus&scoped=true"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47a2bc0"]])

export default __exports__